import proteinAlphabet from "./proteinAlphabet";
export default function getMassOfAaString(aaString, numsAfterDecimal = 2, divideByThree = false) {
  let sumMass = 0;
  for (let i = 0; i < aaString.length; i++) {
    sumMass += proteinAlphabet[aaString[i]].mass;
  }
  if (divideByThree) {
    sumMass /= 3;
  }
  if (aaString.length > 0) {
    sumMass = sumMass + 18.0153;
  }
  return Math.round(sumMass * 10 ** numsAfterDecimal) / 10 ** numsAfterDecimal;
}
